import { render, staticRenderFns } from "./studentbzr.vue?vue&type=template&id=6d1a75d4&scoped=true"
import script from "./studentbzr.vue?vue&type=script&lang=js"
export * from "./studentbzr.vue?vue&type=script&lang=js"
import style0 from "./studentbzr.vue?vue&type=style&index=0&id=6d1a75d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1a75d4",
  null
  
)

export default component.exports